import Shield from "../../assets/svg/Shield.svg";
import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function PermissionDeniedInstall() {
    const [countdown, setCountdown] = useState(10);
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev === 1) {
                    clearInterval(timer);
                    window.location.replace(
                        `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
                    );
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
            <main className="main-content-cancel">
                <div className="icon-container">
                    <img src={Shield} alt="Shield Icon" className="icon-sms" />
                </div>
                <div className="installation-text">
                    <h1 className="title">
                        Your account does not have the necessary <br /> permissions to install
                        this package
                    </h1>
                </div>
                <div className="info-box-cancel">
                    <IconButton style={{ padding: "0px" }}>
                        <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
                    </IconButton>
                    <span className="info-text">
                        An Account is being created on SMS Magic
                    </span>
                </div>
                <div
                    className="workspace-redirect"
                    style={{ marginBottom: "20px", marginTop: "20px" }}
                >
                    Redirecting to workspace in{" "}
                    <span className="timer">{countdown} seconds</span>
                </div>
            </main>
    );
}
